import { render, staticRenderFns } from "./cdConfigInfos.vue?vue&type=template&id=05009ea8&scoped=true"
import script from "./cdConfigInfos.vue?vue&type=script&lang=js"
export * from "./cdConfigInfos.vue?vue&type=script&lang=js"
import style0 from "./cdConfigInfos.vue?vue&type=style&index=0&id=05009ea8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05009ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05009ea8')) {
      api.createRecord('05009ea8', component.options)
    } else {
      api.reload('05009ea8', component.options)
    }
    module.hot.accept("./cdConfigInfos.vue?vue&type=template&id=05009ea8&scoped=true", function () {
      api.rerender('05009ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_reward_configuration/form/components/cdConfigInfos.vue"
export default component.exports